// extracted by mini-css-extract-plugin
export default {"imageWrapper":"AN-z","twoColumnImage":"BN-z"};